export default "__VITE_ASSET__DxgtRkU1__"